"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var common_1 = require("../../../../common");
var HeaderBar_1 = __importDefault(require("../../../../theme/headerbar/HeaderBar"));
var Evaluation_1 = __importDefault(require("./Evaluation"));
var GroupReport_1 = __importDefault(require("./GroupReport"));
var IndividualReport_1 = __importDefault(require("./IndividualReport"));
var InstallationReport_1 = __importDefault(require("./InstallationReport"));
var MonitoringHistoryReport_1 = __importDefault(require("./MonitoringHistoryReport"));
var ServiceAppointmentReport_1 = __importDefault(require("./ServiceAppointmentReport"));
var SynchronizationReport_1 = __importDefault(require("./SynchronizationReport"));
var WatchedVideo_1 = __importDefault(require("./WatchedVideo"));
var headerList = [
    {
        icon: "setting",
        name: "General",
        menu: [
            {
                name: "app_installation",
                key: "app_installation",
            },
            {
                name: "synchronization",
                key: "synchronization",
            },
        ],
    },
    {
        icon: "education",
        name: "Knowledge",
        menu: [
            {
                name: "Watched Video Count",
                key: "watched video count",
            },
            {
                name: "Evaluation Questions",
                key: "Evaluation questions",
            },
        ],
    },
    {
        icon: "service",
        name: "Service",
        menu: [
            {
                name: "Service Appointment",
                key: "service appointment",
            },
        ],
    },
    {
        icon: "myFinance",
        name: "Monitoring",
        menu: [
            {
                name: "Monitoring History",
                key: "monitoring history",
            },
        ],
    },
];
var GeneralReport = function (props) {
    var _a, _b;
    var _c = (0, react_1.useState)((_b = (_a = headerList[0]) === null || _a === void 0 ? void 0 : _a.menu[0]) === null || _b === void 0 ? void 0 : _b.key), subType = _c[0], setSubType = _c[1];
    var _d = (0, react_1.useState)(headerList[0]), type = _d[0], setType = _d[1];
    var _e = (0, react_1.useState)(0), clickedIndex = _e[0], setClickedIndex = _e[1];
    var renderForm = function () {
        if (subType === "app_installation") {
            return react_1.default.createElement(InstallationReport_1.default, null);
        }
        else if (subType === "synchronization") {
            return react_1.default.createElement(SynchronizationReport_1.default, null);
        }
        else if (subType === "Watched Video Count") {
            return react_1.default.createElement(WatchedVideo_1.default, null);
        }
        else if (subType === "Evaluation questions") {
            return react_1.default.createElement(Evaluation_1.default, null);
        }
        else if (subType === "Individual") {
            return react_1.default.createElement(IndividualReport_1.default, null);
        }
        else if (subType === "Group") {
            return react_1.default.createElement(GroupReport_1.default, null);
        }
        else if (subType === "Service Appointment") {
            return react_1.default.createElement(ServiceAppointmentReport_1.default, null);
        }
        else if (subType === "Monitoring History") {
            return react_1.default.createElement(MonitoringHistoryReport_1.default, null);
        }
    };
    var renderBody = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null, type.menu.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(common_1.SubHeader, { path: "".concat(props.match.path), list: type.menu, onSubChangeTab: function (val, index) {
                    // setSubType(val.name);
                    setSubType(val.key);
                    setClickedIndex(index);
                }, clickedIndex: clickedIndex }),
            subType !== "" && renderForm()))));
        // }
    };
    return (react_1.default.createElement(HeaderBar_1.default, { list: headerList, alias: "report", hideSave: true, path: "".concat(props.match.path), title: "report", onChangeTab: function (val) {
            setType(val);
            // setSubType(null);
            setSubType(val.menu[0].name);
            setClickedIndex(0);
        } }, renderBody()));
};
exports.default = GeneralReport;
